// src/pages/ProjectExample.jsx
import './ProjectPage.css'; // separate CSS for project pages


import BioMirror_img1 from '../../assets/images/BioMirror_img1.jpg';
import BioMirror_img2 from '../../assets/images/BioMirror_img2.gif';
import BioMirror_img3 from '../../assets/images/BioMirror_img3.gif';
import BioMirror_img4 from '../../assets/images/BioMirror_img4.gif';
import BioMirror_img5 from '../../assets/images/BioMirror_img5.gif';
import BioMirror_img6 from '../../assets/images/BioMirror_img6.png';




function BioMirror() {
  return (
    <>


      <div className="project-page-wrapper">
        {/* Project title */}
        <h1 className="project-title">BioMirror: A mirror that lets you see inside yourself</h1>

        {/* Introduction text */}
        <p className="project-introduction">
       Biofeedback, like a mirror, enables individuals to see inside their body and improve self-regulation on their physiology to a healthy direction. However, for a long time, Biofeedback is considered only within the context of clinical settings. In this project, we aim to bridge the gap between biofeedback technique and its application in daily life.
       BioMirror is a set of interactive surfaces that respond to users’ heartbeats, respiration and autonomic nervous system activities. As a traditional mirror reflects one’s outside appearance, BioMirror reflects human internal bodily processes. The surface is complex paper-based structure with repetitive incisions created by laser cutting. the rear serves as a medium to transform force from servomotors, vibration motors or fans into an action, stimulating the patterns on the surface to vibrate, swing, bulge or rotate to display physiological information in dynamic physical form.
        </p>

        {/* Image */}
        <div className="project-image">
          <img src={BioMirror_img1} alt="BioMirror_img1" />
        </div>

        {/* Details text */}
        <h2 className="section-title">Concept of BioMirror</h2>
        <p className="project-details-text">
        With BioMirror, we explore a novel shape-changing interface for biofeedback designed for everyday users rather than specialists, with potential applications in living spaces and home environments. 
        The system takes users’ biosignals as input and expresses them through dynamic surface transformations. When integrated with additional biosensors, BioMirror could present a wide range of physiological information. Beyond functioning as a biofeedback interface, 
        BioMirror introduces an innovative concept of sensitive, bio-responsive shape-changing surfaces that could be extended into bio-responsive wallpaper or spatial elements, serving as peripheral displays of users’ physiological states in homes or offices. 
        For example, it could support interventions for chronic stress in the workplace by subtly reflecting changes in a user’s condition and encouraging timely self-regulation.
        </p>

       <div className="project-video">
        <iframe
            src="https://player.vimeo.com/video/145148275"
            width="100%"
            height="450"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Project Video"
        ></iframe>
        </div>

        <h2 className="section-title">Why BioMirror?</h2>
        <p className="project-details-text">
        Biofeedback techniques have long been developed to help individuals acquire self-regulation skills; however, they have traditionally been used in guided therapy sessions under the supervision of trained experts. Consequently, biofeedback is often perceived as a therapeutic tool confined to clinical settings. 
        Most biofeedback systems therefore present feedback in graphic or numeric formats that are convenient for therapists to monitor patients’ physiological processes but are less suitable for everyday users.
        Shape-changing interfaces offer an alternative approach by leveraging physical transformation to enhance interactions with digital information. Qualities such as orientation, volume, texture, and spatial form can be dynamically coupled with data measured from the user or the surrounding environment. 
        In this context, we explore the possibility of developing a paper-based, wall-like surface that displays an individual’s physiological information through dynamic physical changes.
        </p>

        {/* Image */}
        <div className="project-image">
          <img src={BioMirror_img2} alt="BioMirror_img2" />
        </div>

        {/* Image */}
        <div className="project-image">
          <img src={BioMirror_img3} alt="BioMirror_img3" />
            <figcaption className="image-caption">
                BioMirror #1 reflects human breathing movements through dynamic surface transformations. User breathe-in, the surface bulges out; user breathe-out, the surface becomes flat again. The more intense the breathing, the stronger the bulging.
            </figcaption>
        </div>

         {/* Image */}
        <div className="project-image">
          <img src={BioMirror_img4} alt="BioMirror_img4" />
            <figcaption className="image-caption">
            BioMirror #2 reflects human heart beat via the intensity of vibration on the surface. The stronger the heartbeat, the more intense the vibration.
          </figcaption>
        </div>

         {/* Image */}
        <div className="project-image">
          <img src={BioMirror_img5} alt="BioMirror_img5" />
            <figcaption className="image-caption">
               BioMirror #3 reflects human heart rate variability levels through circular movement with various speed. The more stressful the user is, the faster the movement.
            </figcaption>
        </div>

         <h2 className="section-title">Lessons Learned</h2>
        <p className="project-details-text">
         BioMirror was exhibited at the Dutch Invertuals Exhibition during Milan Design Week in Italy in April 2015 and later at Dutch Design Week in October 2015, providing an opportunity to observe how audiences interacted with the shape-changing surfaces. F
         or the exhibition, BioMirror consisted of three wooden frame boxes measuring 40 × 40 × 10 cm (length, height, width), mounted on the wall, with the shape-changing surface fixed to the exterior of each box.
         Most visitors quickly understood the relationship between the biosignals and the surface transformations. This natural mapping between physiological data, such as breathing, and the corresponding shape changes suggests a promising approach for delivering biofeedback information. 
         Beyond its current role as a tangible biofeedback display, many participants perceived BioMirror as a bio-responsive element suitable for public spaces, as well as an art object for the home that could enhance self-awareness of one’s health status.
        </p>

                 {/* Image */}
        <div className="project-image">
          <img src={BioMirror_img6} alt="BioMirror_img6" />
        </div>

        {/* Footer: financing and partners */}
        <div className="project-footer">
          <p><strong>Publication: </strong>  <a href="https://doi.org/10.1145/2839462.283946" target="_blank" rel="noopener noreferrer"> LivingSurface: biofeedback through shape-changing display (TEI'16)</a></p>
          <p><strong>Project Partners:</strong>  <a href="https://www.a-plus-n.com/" target="_blank" rel="noopener noreferrer"> A+N Design Studio</a></p>
        </div>
      </div>
    </>
  );
}

export default BioMirror;
